import {Either, left, right} from "fp-ts/lib/Either"
import {mixed} from "../tsutil"
import {Message} from "semantic-ui-react"
import * as React from "react"

// A type for typenames that aren't "Error".
// `Exclude<string, "Error">` doesn't work. I tried it.
// Update on an as-needed basis (eg when you need errorToEither() to work with a new type).
type GraphQLNonErrorTypename =
  | "AirportAirline"
  | "AirportStop"
  | "Auth0Config"
  | "Booker"
  | "BookerOrNull"
  | "Address"
  | "Booking"
  | "BookingPaymentLink"
  | "BookingStatus"
  | "Charge"
  | "Charges"
  | "LoyaltyProgramDiscount"
  | "CommonPlace"
  | "Driver"
  | "Journey"
  | "Locale"
  // | "Error"
  | "MutationType"
  | "UUIDObj"
  | "Bookings"
  | "BookingsSummary"
  | "BookingsSummaryResult"
  | "SendInvoiceJob"
  | "StripeCharge"
  | "Passenger"
  | "PastPassenger"
  | "Place"
  | "ExtraCharge"
  | "PlaceNickname"
  | "BookingsSeekOut"
  | "BookingsResult"
  | "QueryType"
  | "Bookers"
  | "Drivers"
  | "XeroInvoice"
  | "Invoice"
  | "InvoiceContact"
  | "StripeCard"
  | "StripeCards"
  | "StripeCardOrNull"
  | "StripeConfig"

export interface GraphQLObject<Typename extends string> {
  __typename: Typename
}
export type GraphQLNonError = GraphQLObject<GraphQLNonErrorTypename>
export interface GraphQLError {
  message: string
}
export type OrError<T> = Either<GraphQLError, T>

// This has to match the type of a GraphQL error result *exactly*, otherwise the T in
// errorToEither() doesn't get inferred properly at the call site. That's why "id" and
// "__typename" fields are here even though they're useless.
interface GraphQLErrorResult extends GraphQLError {
  __typename: "Error"
  id: string
}

export function errorUnionToEither<T extends GraphQLNonError>(
  data: T | GraphQLErrorResult,
): OrError<T> {
  return data.__typename === "Error" ? left(data) : right(data)
}

export function newError(message: string): GraphQLError {
  return {message}
}

export function handleError<T>(
  data: Either<{message: string}, T>,
  render: (x: T) => React.ReactElement<mixed> | null,
): React.ReactElement<mixed> | null {
  return data.fold(
    (e) => (
      <Message style={{display: "block"}} error>
        Error: {e.message}
      </Message>
    ),
    render,
  )
}



// WEBPACK FOOTER //
// ./src/graphql/errors.tsx